import React from 'react';
import { List, LayoutGrid } from 'lucide-react';
import './ViewToggle.css';

/* Selector de vista tabla/mosaico (KIT CRECE F4, brief §9: exploración =
   tarjeta). Control segmentado que vive en la toolbar; NO es un filtro (no
   cambia qué se ve, sino CÓMO) — por eso va a la derecha, separado de los
   filtros. Genérico: el caller pasa las opciones que quiera. */
const DEFAULTS = [
  { id: 'table', label: 'Tabla', icon: List },
  { id: 'grid', label: 'Mosaico', icon: LayoutGrid },
];

export default function ViewToggle({ value, onChange, options = DEFAULTS, ariaLabel = 'Modo de vista' }) {
  return (
    <div className="ui-viewtoggle" role="group" aria-label={ariaLabel}>
      {options.map((o) => {
        const Icon = o.icon;
        const active = value === o.id;
        return (
          <button
            key={o.id}
            type="button"
            className={`ui-viewtoggle-btn${active ? ' is-active' : ''}`}
            aria-pressed={active}
            title={o.label}
            onClick={() => onChange?.(o.id)}
          >
            {Icon && <Icon size={15} aria-hidden="true" />}
            <span className="ui-viewtoggle-lbl">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
